<template>
  <div class="service">
    <div class="container">
      <div class="box">
        <div class="title">
          <div class="en">
            <p>services available</p>
            <p>world-wide</p>
          </div>
<!--          <div class="cn">世界各地的服务</div>-->
        </div>
        <div class="content" v-html="this.column[6].content">
        </div>
        <div class="link flex flex-space-between flex-align-center" @click="goto">
          <div class="txt">
            <div class="t1">more about</div>
            <div class="t2">FUNJOY</div>
          </div>
          <i class="fa fa-arrow-right"></i>
        </div>
      </div>
      <div class="map">
        <img src="/images/map.png" alt>
        <div class="hint beimei">
          <div class="hint-radius"></div>
          <div class="hint-dot"></div>
          <div class="hint-content">
            <p>NORTH AMERICA</p>
          </div>
        </div>
        <div class="hint ouzhou">
          <div class="hint-radius"></div>
          <div class="hint-dot"></div>
          <div class="hint-content">
            <p>EUROPE</p>
          </div>
        </div>
        <div class="hint yatai">
          <div class="hint-radius"></div>
          <div class="hint-dot"></div>
          <div class="hint-content">
            <p>ASIA PACIFIC</p>
          </div>
        </div>
        <div class="hint zhongdong">
          <div class="hint-radius"></div>
          <div class="hint-dot"></div>
          <div class="hint-content">
            <p>THE MIDDLE EAST</p>
          </div>
        </div>
        <div class="hint dayang">
          <div class="hint-radius"></div>
          <div class="hint-dot"></div>
          <div class="hint-content">
            <p>OCEANIA</p>
          </div>
        </div>
        <div class="ningbo">
          <div class="tq1"></div>
          <div class="tq2"></div>
          <div class="tq3"></div>
          <div class="content">
            <img src="@/assets/logo_w.svg" alt>
            <div>
              <div class="txt">
                <p>CHINA NINGBO</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {get_column} from "../../../util/lang";
export default {
  components: {},
  data() {
    return {
      column:'',
    };
  },
  methods: {
    goto(){
      this.$router.push({
        name: 'about',
        params: {
          tid: 1
        }
      })
    },
    fetchDate(){
      const url = get_column();
      this.$$axios.get(url).then(res => {
        this.column = res.data
        // console.log(this.banner)
        // this.banner.map((item)=>{
        //   item.EN=item.EN.replace(/\n/g, "<br>")
        // })
      }).then(()=>{

      })
    },
  },
  created() {
    this.fetchDate()
  }
};
</script>

<style scoped>
.service {
  background-color: #242a33;
  padding: 50px 0;
}
.service .container {
  max-width: 1500px;
  margin: 0 auto;
  position: relative;
  padding-top: 100px;
  overflow: hidden;
}
.service .container .box {
  color: #fff;
  max-width: 550px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  pointer-events: none;
}
.service .container .box .title {
  border-bottom: 1px solid rgba(141, 144, 149, 0.5);
  padding: 25px;
  pointer-events: auto;
}
.service .container .box .title .en {
  font-size: 40px;
  text-transform: uppercase;
  font-family: "CANARO BOLD";
}
.service .container .box .title .cn {
  font-size: 35px;
}
.service .container .box .content {
  font-size: 14px;
  color: #efefef;
  line-height: 30px;
  padding: 25px;
  pointer-events: none;
}
.service .container .box .content img {
  width: 230px;
  display: block;
}
.service .container .box .link {
  font-family: "CANARO BOLD";
  border: 1px solid #fff;
  color: #fff;
  padding: 5px 10px;
  text-transform: uppercase;
  width: 250px;
  max-width: 100%;
  margin-top: 25px;
  margin-left: 25px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: 0.3s;
  pointer-events: auto;
}
.service .container .box .link .txt {
  position: relative;
}
.service .container .box .link .txt .t1 {
  font-size: 20px;
  line-height: 1em;
}
.service .container .box .link .txt .t2 {
  font-size: 16px;
  line-height: 1em;
}
.service .container .box .link i {
  transition: 0.3s;
  position: relative;
}
.service .container .box .link::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background-color: #004b94;
  transition: 0.3s;
  border-radius: 0 50px 50px 0;
  border-right: 50px solid #004b94;
  margin-left: -50px;
}
.service .container .box .link:hover::before {
  left: 0;
  margin-left: 0;
}
.service .container .box .link:hover {
  color: #fff;
}
.service .container .map {
  max-width: 1339px;
  margin: 0 auto;
  position: relative;
  overflow: hidden;
}
.service .container .map > img {
  width: 100%;
}
.service .container .map .hint {
  position: absolute;
  width: 60px;
  height: 60px;
  transition: opacity 0.5s ease, transform 0.5s cubic-bezier(0.5, 0, 0, 1),
    -webkit-transform 0.5s cubic-bezier(0.5, 0, 0, 1);
  transition-delay: 1s;
}
.service .container .map .hint::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 8px;
  height: 8px;
  background-color: #fff;
  border-radius: 50%;
}
.service .container .map .hint::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 2px;
  height: 2px;
  border-radius: 50%;
  transition: opacity 0.5s ease;
  animation: home_hero_item_hints_glow 2s cubic-bezier(0.25, 0.1, 0.2, 1)
    infinite;
}
.service .container .map .hint:hover::after {
  opacity: 0;
}

@keyframes home_hero_item_hints_glow {
  0% {
    box-shadow: 0 0 30px 5px #fff;
  }
  70% {
    box-shadow: 0 0 70px 50px rgba(72, 170, 72, 0);
  }
  100% {
    box-shadow: 0 0 0 50px rgba(72, 170, 72, 0);
  }
}
.service .container .map .hint .hint-radius {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 250px;
  height: 250px;
  margin: -125px 0 0 -125px;
  border-radius: 50%;
  transition-property: background-color, opacity, visibility, transform,
    -webkit-transform;
  transition-timing-function: ease, ease, ease, cubic-bezier(0.5, 0, 0, 1);
  transition-duration: 0.5s;
  opacity: 0;
  visibility: hidden;
  transform: scale(0);
}
.service .container .map .hint:hover .hint-radius {
  background-color: #fff;
  opacity: 0.1;
  visibility: visible;
  transform: scale(1);
}
.service .container .map .hint .hint-dot {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60px;
  height: 60px;
  border-radius: 50%;
  border: 1px solid;
  animation: home_hero_item_hints_border 2s linear infinite;
}
@keyframes home_hero_item_hints_border {
  0%,
  100% {
    border-color: rgba(255, 255, 255, 0.6);
    -webkit-transform: translate(-50%, -50%) scale(0.95);
    transform: translate(-50%, -50%) scale(0.95);
  }
  50% {
    border-color: rgba(255, 255, 255, 0.3);
    -webkit-transform: translate(-50%, -50%) scale(1);
    transform: translate(-50%, -50%) scale(1);
  }
}
.service .container .map .hint .hint-content {
  position: absolute;
  width: 180px;
  color: #fff;
  z-index: 5;
  padding: 12px 0;
  font-size: 12px;
  color: #b0b0b0;
  transition: opacity 0.7s ease, visibility 0.7s ease;
  opacity: 0;
  visibility: hidden;
}
.service .container .map .hint:hover .hint-content {
  opacity: 1;
  visibility: visible;
}
.service .container .map .hint .hint-content::before,
.service .container .map .hint .hint-content::after {
  content: "";
  position: absolute;
  height: 1px;
  background-color: #fff;
  transition: opacity 0.5s ease;
  opacity: 0;
}
.service .container .map .hint .hint-content::before {
  width: 180px;
}
.service .container .map .hint .hint-content::after {
  width: 80px;
}
.service .container .map .hint:hover .hint-content::before,
.service .container .map .hint:hover .hint-content::after {
  opacity: 1;
}
.service .container .map .hint:hover .hint-content::before {
  transition-delay: 0.15s;
}
.service .container .map .hint .hint-content p {
  opacity: 0;
  transition-delay: 0.3s;
}
.service .container .map .hint:hover .hint-content p {
  opacity: 1;
}
.service .container .map .hint.beimei {
  top: calc(41.64% - 30px);
  left: calc(19.29% - 30px);
}
.service .container .map .hint.beimei .hint-content {
  top: 85px;
  right: 50%;
  transform: translateX(100%);
  margin-right: -55px;
}
.service .container .map .hint.beimei .hint-content::before {
  top: 0;
  left: 0;
}
.service .container .map .hint.beimei .hint-content::after {
  top: 0;
  left: 0;
  transform: rotate(-135deg);
  transform-origin: 0 50%;
}
.service .container .map .hint.zhongdong {
  top: calc(51.64% - 30px);
  left: calc(60.29% - 30px);
}

.service .container .map .hint.zhongdong .hint-content {
  top: 85px;
  right: 50%;
  transform: translateX(100%);
  margin-right: -55px;
}
.service .container .map .hint.zhongdong .hint-content::before {
  top: 0;
  left: 0;
}
.service .container .map .hint.zhongdong .hint-content::after {
  top: 0;
  left: 0;
  transform: rotate(-135deg);
  transform-origin: 0 50%;
}

.service .container .map .hint.ouzhou {
  top: calc(34.5% - 30px);
  left: calc(48.47% - 30px);
}
.service .container .map .hint.ouzhou .hint-content {
  top: 85px;
  left: 50%;
  transform: translateX(-100%);
  margin-left: -55px;
}
.service .container .map .hint.ouzhou .hint-content::before {
  top: 0;
  right: 0;
}
.service .container .map .hint.ouzhou .hint-content::after {
  top: 0;
  right: 0;
  transform: rotate(135deg);
  transform-origin: 100% 50%;
}
.service .container .map .hint.yatai {
  top: calc(40.5% - 30px);
  left: calc(73.52% - 30px);
}
.service .container .map .hint.yatai .hint-content {
  bottom: 85px;
  right: 50%;
  transform: translateX(100%);
  margin-right: -55px;
}
.service .container .map .hint.yatai .hint-content::before {
  bottom: 0;
  left: 0;
}
.service .container .map .hint.yatai .hint-content::after {
  bottom: 0;
  left: 0;
  transform: rotate(135deg);
  transform-origin: 0% 50%;
}
.service .container .map .hint.nanmei {
  top: calc(50.06% - 30px);
  left: calc(40.24% - 30px);
}
.service .container .map .hint.nanmei .hint-content {
  bottom: 85px;
  right: 50%;
  transform: translateX(100%);
  margin-right: -55px;
}
.service .container .map .hint.nanmei .hint-content::before {
  bottom: 0;
  left: 0;
}
.service .container .map .hint.nanmei .hint-content::after {
  bottom: 0;
  left: 0;
  transform: rotate(135deg);
  transform-origin: 0% 50%;
}
.service .container .map .hint.dayang {
  top: calc(78.13% - 30px);
  left: calc(84.86% - 30px);
}
.service .container .map .hint.dayang .hint-content {
  bottom: 85px;
  right: 50%;
  transform: translateX(100%);
  margin-right: -55px;
}
.service .container .map .hint.dayang .hint-content::before {
  bottom: 0;
  left: 0;
}
.service .container .map .hint.dayang .hint-content::after {
  bottom: 0;
  left: 0;
  transform: rotate(135deg);
  transform-origin: 0% 50%;
}
.service .container .map .ningbo {
  position: absolute;
  top: 48.72%;
  left: 80.29%;
}
.service .container .map .ningbo::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 8px;
  height: 8px;
  background-color: #fff;
  border-radius: 50%;
}
.service .container .map .ningbo .tq1 {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 8px;
  height: 8px;
  margin: -4px 0 0 -4px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.2);
  animation: bianda 2.5s infinite linear;
}
.service .container .map .ningbo .tq2 {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 8px;
  height: 8px;
  margin: -4px 0 0 -4px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.1);
  animation: bianda2 2s infinite linear;
}
.service .container .map .ningbo .tq3 {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 8px;
  height: 8px;
  margin: -4px 0 0 -4px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.1);
  animation: bianda3 3s infinite linear;
}
.service .container .map .ningbo .content {
  position: absolute;
  left: 20px;
  bottom: -10px;
  font-size: 12px;
  color: #fff;
}
.service .container .map .ningbo .content img {
  margin-left: -70px;
  width: 230px;
}
@keyframes bianda {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(10);
  }
}
@keyframes bianda2 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(13);
  }
}
@keyframes bianda3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(17);
  }
}
@media (max-width: 1500px) {
  .service .container .box .title .en {
    font-size: 28px;
  }
}
@media (max-width: 768px) {
  .service .container{
    padding-top: 0;
  }
  .service .container .box .title .en{
    font-size: 24px;
  }
  .service .container .box .title .cn{
    font-size: 20px;
  }
  .service .container .map .hint,
  .service .container .map .ningbo{
    display: none;
  }
  .service .container .box{
    position: static;
    padding-bottom: 50px;
  }
}
</style>


